import axios from 'axios';
import get from 'lodash.get';

import LocalStorageService from '@/services/LocalStorageService';
import { AppErrorService } from '@/services/AppErrorService';

import { STATUS_CODES } from '@/constants/errors';
import { BACKEND_VERSION_HEADER } from '@/constants/storage';

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

const authInterceptor = config => {
  const updatedConfig = { ...config };
  const token = LocalStorageService.getToken();

  if (token) {
    updatedConfig.headers.Authorization = `Bearer ${token}`;
  }

  return updatedConfig;
};

const XHR_NETWORK_ERROR_MESSAGE = 'Network Error';

const errorInterceptor = error => {
  const hasToken = !!LocalStorageService.getToken();
  const { response } = error;

  if (error && error.message === XHR_NETWORK_ERROR_MESSAGE) {
    AppErrorService.addError({
      error,
      details: {
        message: 'common.errorNotification.checkInternetConnection'
      }
    });
  } else if (response && response.status === 500) {
    AppErrorService.addError({
      error,
      details: { message: 'common.errorNotification.oops', withSendReport: true }
    });
  }

  if (response && response.status === STATUS_CODES.UNAUTHORIZED && hasToken) {
    LocalStorageService.clearStorage();
  }

  return Promise.reject(error);
};

const checkBackendVersionInterceptor = response => {
  const storageVersion = LocalStorageService.getBackendVersion();

  const responseVersion = get(response, ['headers', BACKEND_VERSION_HEADER], null);

  if (!storageVersion) {
    LocalStorageService.setBackendVersion(responseVersion);
  }

  if (storageVersion && responseVersion && storageVersion !== responseVersion) {
    LocalStorageService.setBackendVersion(responseVersion);
    window.location.reload();
  }

  return Promise.resolve(response);
};

httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.response.use(response => response, errorInterceptor);
httpClient.interceptors.response.use(response => checkBackendVersionInterceptor(response));

export default httpClient;
